Reflux = require 'reflux'

module.exports = Reflux.createStore
  init: ->
    @products = [
      {
        key: 'anejo'
        title: 'ANEJO'
        description: 'SANTERA’S ARTISANAL AÑEJO IS AGED WITH EXTRA CARE FOR AN EXTENDED 22 MONTHS TO EMBOLDEN THE EXUBERANT, COMPLEX FLAVORS OF THIS ELEGANT TEQUILA. THIS IS A DARK, BROODING AND MULTIFARIOUS AÑEJO, WITH A FRAGRANT WALNUT NOSE AND SOFT, SMOOTH YET MOSAIC TASTE.'
        video: 'video-56'
      }
      {
        key: 'blanco'
        title: 'BLANCO'
        description: 'SANTERA’S SILVER TEQUILA ELIMINATES THE HARSH BITE TYPICAL OF MINIMALLY AGED TEQUILAS BY ALLOWING THE LIQUID TO REPOSE FOR AN UNORTHODOX EIGHT MONTHS. THE RESULT IS A SMOOTHER, ROUNDER SILVER TEQUILA.'
        video: 'video-127'
      }
      {
        key: 'reposado'
        title: 'REPOSADO'
        description: 'THE SANTERA REPOSADO EXCEEDS INDUSTRY STANDARDS BY MATURING FOR 16 MONTHS WITHIN FRENCH OAK BARRELS. THIS UNIQUE BLEND TAKES ON A GOLDEN HUE, AND SUCCESSFULLY BALANCES THE SWEET AGAVE FLAVORS WITH THE AROMATIC HINT OF THE SMOKY FRENCH OAK, OBTAINING A RICHER, MORE NUANCED TEQUILA.'
        video: 'video-115'
      }
    ]



/** WEBPACK FOOTER **
 ** ./src/scripts/stores/product-store.coffee
 **/